<template>
  <v-container class="my-10">
    <v-row>
      <v-col cols="12" md="12" class="align-self-center">
        <v-card flat>
          <v-card-text>
            <v-row justify="center" class="black--text">
              <v-col cols="12" md="5">
                <div class="mb-5">
                  <h2 class="text-md-h4 font-weight-bold sub-title-page">
                    Pengaduan PMB
                  </h2>
                </div>
                <div class="mb-3">
                  <div class="foot-list-content">
                    <strong>
                      Untuk Pengaduan Penerimaan Mahasiswa Baru Politeknik Negeri Bali dapat menghubungi:
                    </strong>
                  </div>
                </div>
                <div class="mb-1">
                  <div class="foot-list-icon float-left">
                    <v-icon :color="maincolor">
                      phone
                    </v-icon>
                  </div>
                  <div class="foot-list-content">
                    Telephone <a href="tel:+62361701981">0361-701981</a> ext.109 (Akademik) atau ext. 125 (bagian IT/Puskom)
                  </div>
                </div>
                <div class="mb-5">
                  <div class="foot-list-icon float-left">
                    <v-icon :color="maincolor">
                      email
                    </v-icon>
                  </div>
                  <div class="foot-list-content">
                    WA Center BAAK (<a href="whatsapp://send?phone=+6285847301163">085847301163</a> dan <a href="whatsapp://send?phone=+6285847301164">085847301164</a>)
                  </div>
                </div>
                <div>
                  <v-divider></v-divider>
                </div>
                <div class="mt-5">
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor"
                    href="https://www.facebook.com/PoltekBali/"
                    target="_blank">
                    <v-icon :color="maincolor">
                      mdi-facebook
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor"
                    href="https://www.youtube.com/c/PoliteknikNegeriBaliOfficial"
                    target="_blank">
                    <v-icon :color="maincolor">
                      mdi-youtube
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor"
                    href="https://www.instagram.com/politeknik_negeri_bali"
                    target="_blank">
                    <v-icon :color="maincolor">
                      mdi-instagram
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-2"
                    small
                    fab
                    outlined
                    :color="maincolor"
                    href="https://id.linkedin.com/school/politeknik-negeri-bali/"
                    target="_blank">
                    <v-icon :color="maincolor">
                      mdi-linkedin
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                <!-- <v-divider vertical></v-divider> -->
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-5" v-if="false">
                  <h2 class="text-md-h5">
                    Direction
                  </h2>
                  <p>
                    Got a question? We'd love to here from you. Send us a message and we'll response as soon as possible.
                  </p>
                </div>
                <div>
                  <iframe
                    width="100%"
                    height="280"
                    frameborder="0"
                    scrolling="no"
                    marginheight="0"
                    marginwidth="0"
                    src="https://www.openstreetmap.org/export/embed.html?bbox=115.1570498943329%2C-8.803378282432833%2C115.16526818275453%2C-8.797334840290567&amp;layer=mapnik&amp;marker=-8.80035657369752%2C115.1611590385437">
                  </iframe>
                  <br/>
                  <a href="https://www.google.com/maps/dir//Bali+State+Polytechnic,+Kampus+Bukit,+Jimbaran,+South+Kuta,+Badung+Regency,+Bali+80364/@-8.7988737,115.1593864,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x2dd244c13ee9d753:0x6c05042449b50f81!2m2!1d115.161686!2d-8.7991152" target="_blank">
                    Get direction
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Pengaduanpmb',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    datakuota: [
      {
        kdprodi: '617001',
        prodi: 'MANAJEMEN PROYEK KONSTRUKSI',
        total: '150',
        snbp: '38',
        psnbp: '25,33 %',
        snbt: '68',
        psnbt: '45,33 %',
        mandiri: '44',
        pmandiri: '29,33 %',
      },
      {
        kdprodi: '617002',
        prodi: 'TEKNOLOGI REKAYASA UTILITAS',
        total: '60',
        snbp: '15',
        psnbp: '25,00 %',
        snbt: '27',
        psnbt: '45,00 %',
        mandiri: '18',
        pmandiri: '30,00 %',
      },
      {
        kdprodi: '617003',
        prodi: 'TEKNIK OTOMASI',
        total: '90',
        snbp: '23',
        psnbp: '25,56 %',
        snbt: '41',
        psnbt: '45,56 %',
        mandiri: '26',
        pmandiri: '28,89 %',
      },
    ],
    word: 'Vue',
    dmodal: {
      register: false,
    },
    regflag: false,
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    submitContact() {
      this.alertdata.show = false;
      if (this.$refs.formcontact.validate()) {
        this.loading.contact = true;
        this.axios
          .post(
            this.api + '/public/contact',
            qs.stringify(
              this.contact,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            this.alertdata.show = true;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data === 1) {
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Thank you for getting in touch!';
                } else {
                  this.alertdata.type = 'error';
                  this.alertdata.text = 'Sorry we get error in your sending email, please try again!';
                }
              } else {
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.contact = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.contact = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
